import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import { COMMON_API } from "../../commonAPI";

const EditHomeFeature = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const token = sessionStorage.getItem("authToken");

  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [image, setImage] = useState(null);
  const [previewImage, setPreviewImage] = useState(null);
  const [currentImage, setCurrentImage] = useState("");

  useEffect(() => {
    const fetchFeature = async () => {
      try {
        const res = await axios.get(`${COMMON_API}/loan/getSingleHomeFeatures/${id}`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        const feature = res.data.feature || {};
        setTitle(feature.title || "");
        setDescription(feature.description || "");
        setCurrentImage(feature.image || "");
      } catch (err) {
        console.error("Error fetching feature:", err);
      }
    };
    fetchFeature();
  }, [id, token]);

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    setImage(file);
    setPreviewImage(file ? URL.createObjectURL(file) : null);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!title.trim() || !description.trim()) {
      alert("Title and description are required");
      return;
    }

    const formData = new FormData();
    formData.append("title", title);
    formData.append("description", description);
    if (image) formData.append("image", image);

    try {
      await axios.put(`${COMMON_API}/loan/editHomeFeatures/${id}`, formData, {
        headers: { Authorization: `Bearer ${token}` },
      });
      navigate("/home-features");
    } catch (err) {
      console.error("Error updating feature:", err);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100 p-6">
      <div className="w-full max-w-lg bg-white rounded-2xl shadow-lg p-8">
        <h2 className="text-2xl font-bold mb-6 text-gray-800">Edit Home Feature</h2>

        <form onSubmit={handleSubmit} className="space-y-5" encType="multipart/form-data">
          <div>
            <label className="block text-gray-600 font-medium mb-1">Title</label>
            <input
              type="text"
              value={title}
              onChange={(e) => setTitle(e.target.value)}
              placeholder="Enter feature title"
              className="w-full border border-gray-300 rounded-lg px-4 py-2 focus:ring-2 focus:ring-blue-500"
              required
            />
          </div>

          <div>
            <label className="block text-gray-600 font-medium mb-1">Description</label>
            <textarea
              rows="3"
              value={description}
              onChange={(e) => setDescription(e.target.value)}
              placeholder="Edit feature description..."
              className="w-full border border-gray-300 rounded-lg px-4 py-2 focus:ring-2 focus:ring-blue-500"
              required
            />
          </div>

          <div>
            <label className="block text-gray-600 font-medium mb-1">Image</label>
            <input
              type="file"
              accept="image/*"
              onChange={handleImageChange}
              className="w-full border border-gray-300 rounded-lg px-3 py-2"
            />
          </div>

          {currentImage && !previewImage && (
            <div>
              <p className="text-gray-600">Current Image:</p>
              <img
                src={`${COMMON_API}/ImgUploads/${currentImage}`}
                alt="Current"
                className="w-32 h-24 object-cover rounded-md border"
              />
            </div>
          )}

          {previewImage && (
            <div>
              <p className="text-gray-600">New Preview:</p>
              <img
                src={previewImage}
                alt="Preview"
                className="w-32 h-24 object-cover rounded-md border"
              />
            </div>
          )}

          <button
            type="submit"
            className="w-full bg-green-600 text-white py-2 rounded-lg hover:bg-green-700 transition"
          >
            Update Feature
          </button>
        </form>
      </div>
    </div>
  );
};

export default EditHomeFeature;
